
import Config from 'Config'
import ReactGTM from 'react-gtm-module';
import ReactPixel from 'react-facebook-pixel';

const advancedMatching = { }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const options = {
  autoConfig: true, // set pixel's autoConfig
  debug: false, // enable logs
};
export const initializeGTM = async () => {

      // Initialize Analytics
    const gtmid = Config.GTM.gtmid;
    const fbPixel  = Config.GTM.fbPixelID;
    if (Config.GTM.enabled) {
        const tagManagerArgs = {
            gtmId: gtmid,
        //   preview:''
        }
        ReactGTM.initialize(tagManagerArgs);
        ReactPixel.init(fbPixel, advancedMatching, options);
        ReactPixel.pageView();
    }   
}

export const pageView = async (path, title) => {

    if (Config.GTM.enabled) {
        window.dataLayer.push({
            event: 'pageview',
            page: {
              url: path,
              title: title
            }
          });        
    }
}


export const logBuyerSignIn = async (user) => {

    try {
        if (Config.GTM.enabled) {
            window.dataLayer.push({
            event: 'GAEvent',
            eventProps: {
                category: "Authentication",
                action: "SignIn",
                value: user.Buyer.buyerID,
                label: "Sign In",
            }
          });        
        }        
    }
    catch{}    
}


export const logBuyerSignUp = async (user) => {

    try {
        if (Config.GTM.enabled) {
            window.dataLayer.push({
            event: 'GAEvent',
            eventProps: {
                category: "Authentication",
                action: "SignUp",
                value: user.Buyer.buyerID,
                label: "Sign Up",
            }
          });        
        }        
    }
    catch{}    
    
}

export const logNewBooking = async (category, service, templateID) => {

    try {
        if (Config.GTM.enabled) {
            window.dataLayer.push({
            event: 'GAEvent',
            eventProps: {
                category: "Booking",
                action: "New",
                value: service,
                label: "New Booking",
            }
          });        
        }        
    }
    catch{}    
}


export const logNewRequest = async (service, user, templateID) => {

    try {
        if (Config.GTM.enabled) {
            window.dataLayer.push({
            event: 'GAEvent',
            eventProps: {
                category: "Request",
                action: "New",
                value: user.Buyer.buyerID,
                label: "New Request",
            }
          });        
        }        
    }
    catch{}    
}

export const logSubmitFormClicked = async (service, user, templateID) => {

    try {
        if (Config.GTM.enabled) {
            window.dataLayer.push({
            event: 'GAEvent',
            eventProps: {
                category: "Engagement",
                action: "RequestFormSubmitClicked",
                value: service.name,
                label: "Request Form Submit Clicked",
            }
          });        
        }        
    }
    catch{}
}


export const logSubmitFormValidated = async (service, user, templateID) => {

    try {
        if (Config.GTM.enabled) {
            window.dataLayer.push({
            event: 'GAEvent',
            eventProps: {
                category: "Engagement",
                action: "SubmitFormValidated",
                value: service.name,
                label: "Request Form Submit Validated",
            }
          });        
        }        
    }
    catch{}
}



